<template>

    <div id="login-agencies" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mb-2" id="exampleModalCenterTitle">Partner</h5>
                    <button type="button" class="btn btn-xs btn-icon btn-ghost-secondary" data-dismiss="modal" aria-label="Close">
                        <i class="tio-clear tio-lg"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="table-responsive datatable-custom">
                        <table id="datatable" class="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table">
                            <thead class="thead-light">
                            <tr>
                                <th>Nome</th>
                                <th>Indirizzo</th>
                                <th>Comune</th>
                                <th>Stato</th>
                                <th></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr v-for="agency in this.agencies">
                                <td>
                                    <strong>{{agency.name}}</strong>
                                </td>
                                <td>{{agency.address}} {{agency.zip}}</td>
                                <td>{{agency.municipality}}</td>
                                <td>
		                  		<span v-if="agency.user && agency.user.id">
		                  			<span class="legend-indicator bg-success"></span> Utente associato
		                  		</span>
                                    <span v-else>
		                  			<span class="legend-indicator"></span> Nessun utente associato
		                  		</span>
                                </td>
                                <td class="actions">
                                    <a :href="route('impersonate.agency', agency.id)" class="btn btn-sm btn-link" v-if="agency.user">
                                        <i class="tio-sign-in"></i>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Label from "@/Jetstream/Label";

export default {

    props: ['agencies'],

    components: {Label},

    data() {
        return {
            label: ''
        }
    },

    methods: {
        addFieldEvent(event) {
            this.$emit('add-field', {label: this.label, amount: 0}, this.category);
        }
    }
}

</script>
